export default "__VITE_ASSET__edbb6040__"